import React, { Component, memo } from 'react';
import { Collapse, CircularProgress, Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography, Button, InputAdornment, TablePagination, ButtonBase } from '@material-ui/core';
import SyncAltIcon from '@material-ui/icons/SyncAlt';
import ColHeader, { sort } from '../../Common/SortableTableHeader';
import { SupplierMappingsProps } from '../connected/SupplierMappingsCnn';
import { SupplierProductsSearchBoxCnn } from '../../ProductsSearch/connected/SupplierProductsSearchBoxCnn';
import { SupplierProductMapping } from '../../api/models/SupplierProductMapping';

import SearchBar from '../../Common/SearchBar';
import PriceInput from './PriceInput';
import { QmoModal } from '../../Layout/components/QmoModal';
import OfferFileLoader from './OfferFileLoader';
import AddNewProduct from './AddNewProduct';

const pageSizes = [10, 25, 50]

type State = {
    sortField: string | null,
    sortAscending: boolean,
    collapsedRow: string | null,
    nextToCollapse: string | null,
    noSearchResults: boolean,
    rowsPerPage: number,
    currentPage: number,
    searchResults: SupplierProductMapping[] | null,
    supplierMappings: SupplierProductMapping[] | null,
    loadFromFileModalOpen: boolean,
    addNewProductModalOpen: boolean,
}


type NumberOfMappingsProps = { mappings: SupplierProductMapping[] }
const NumberOfMappings = memo<NumberOfMappingsProps>((props) => {
    if (props.mappings) {
        let all = props.mappings.length
        let mapped = props.mappings.filter(m => m._isMapped).length
        let notMapped = all - mapped
        return <Typography variant="h2">You have mapped <b>{mapped}</b> products out of <b>{all}</b>.<br /> Map remainig <b>{notMapped}</b> products!</Typography>
    }
    else return <div></div>
})

class SupplierMappings extends Component<SupplierMappingsProps, State> {
    constructor(props: SupplierMappingsProps) {
        super(props)

        this.state = {
            sortField: null,
            sortAscending: false,
            collapsedRow: null,
            nextToCollapse: null,
            noSearchResults: false,
            rowsPerPage: pageSizes[0],
            currentPage: 0,
            supplierMappings: null,
            loadFromFileModalOpen: false,
            addNewProductModalOpen: false,
            searchResults: null
        }
    }

    componentDidMount() {
        this.props.getSupplierMappings()
    }

    handleChangePage = (event: any, page: number) => {
        this.setState({ currentPage: page })
    }

    handleChangeRowsPerPage = (event: any) => {
        let visibleProducts = Math.min((this.state.currentPage) * this.state.rowsPerPage, this.props.supplierMappings!.length)
        this.setState({ rowsPerPage: event.target.value, currentPage: Math.floor((visibleProducts > 0 ? visibleProducts - 1 : 0) / Number(event.target.value)) })
    }

    getCurrentProductsPage(supplierMappings: SupplierProductMapping[]) {
        let current: SupplierProductMapping[] = []
        if (this.state.searchResults) {
            let ids = this.state.searchResults.map(sr => sr.supplierProductId)
            current = supplierMappings.filter(sm => ids.find(id => sm.supplierProductId === id) !== undefined)
        }
        else
            current = supplierMappings

        return current
    }

    saveMapping = (m: SupplierProductMapping) => {
        this.props.updateMapping(m)
    }

    renderStatusCell(spm: SupplierProductMapping, index: string) {
        if (spm._isMapped)
            return (
                <ButtonBase
                    onClick={(e) => {
                        if (this.state.collapsedRow === null)
                            this.setState({ collapsedRow: index })
                        else
                            this.setState({ collapsedRow: null, nextToCollapse: this.state.collapsedRow === index ? null : index });
                    }}
                >
                    <Grid container>
                        <Grid item sm={12}>
                            <SyncAltIcon style={{ color: 'green' }} />
                        </Grid><Grid item sm={12}>
                            <Typography style={{ color: 'green' }} variant="h4">MAPPED</Typography>
                        </Grid>
                        <Grid item sm={12}>
                            <Typography variant="body2">(Click to edit)</Typography>
                        </Grid>
                    </Grid>
                </ButtonBase>
            )
        else
            return (
                <ButtonBase
                    onClick={(e) => {
                        if (this.state.collapsedRow === null)
                            this.setState({ collapsedRow: index })
                        else
                            this.setState({ collapsedRow: null, nextToCollapse: this.state.collapsedRow === index ? null : index });
                    }}>
                    <Grid container>
                        <Grid item sm={12}>
                            <Typography variant="h2" color="error">?</Typography>
                        </Grid><Grid item sm={12}>
                            <Typography variant="h4" color="error">UNMAPPED</Typography>
                        </Grid><Grid item sm={12}>
                            <Typography variant="body2">(Click to map)</Typography>
                        </Grid>
                    </Grid>
                </ButtonBase>)
    }

    renderCatalogueIdCell(spm: SupplierProductMapping) {
        if (spm._isMapped) {
            let boxing = spm.catalogueReference!.units.find(u => u.id === spm.boxingType)!
            let boxingLabel = boxing ? boxing.name : spm.boxingType
            return (
                <div>
                    <Typography variant="subtitle2"><b>Name: </b>{spm.catalogueReference!.name}</Typography>
                    <Typography variant="subtitle2"><b>Boxing: </b>{boxingLabel}</Typography>
                </div>
            )
        }
        else
            return <Typography variant="body1">We can't sell this product untill it's mapped!</Typography>
    }

    onSort(sortField: string | null, sortAscending: boolean) {
        this.setState({ sortField, sortAscending })
    }

    applyPaging(results: SupplierProductMapping[]) {
        return results.slice(this.state.currentPage * this.state.rowsPerPage, this.state.currentPage * this.state.rowsPerPage + this.state.rowsPerPage)
    }

    searchResults(results: SupplierProductMapping[], searching: boolean) {
        let noSearchResults = (results.length === 0 && searching)
        this.setState({ searchResults: results.length > 0 ? results : null, noSearchResults, currentPage: 0 })
    }

    getParent = (elem: HTMLElement | null, className: string): HTMLElement | Element | null => {
        let currParent = elem!.parentElement
        while (currParent) {
            if (currParent!.classList.contains(className))
                return currParent
            else
                currParent = currParent.parentElement
        }
        return null
    }

    render() {
        return (
            <div>
                {this.props.supplierMappings === null || this.props.getMappingsBusy ?
                    <div style={{ textAlign: 'center' }}>
                        <CircularProgress size={50} />
                    </div>
                    :
                    <div>
                        <Grid container alignContent="center" alignItems="center">
                            <Grid item xs={12} sm={7}>
                                <NumberOfMappings mappings={this.props.supplierMappings} />
                            </Grid>

                            {(this.props.supplier && this.props.supplier!.useExternalSystem !== true) &&
                                <Grid container spacing={1} item xs={12} sm={5}>
                                    <Grid item sm>
                                        <Button onClick={() => { this.setState({ addNewProductModalOpen: true, collapsedRow: null }) }} color="primary" variant="contained">Add new product</Button>
                                    </Grid>
                                    <Grid item sm>
                                        <Button onClick={() => { this.setState({ loadFromFileModalOpen: true }) }} color="primary" variant="contained">Load from file</Button>
                                    </Grid>
                                </Grid>
                            } 

                            <Grid item xs={10} sm={5} style={{ marginTop: '20px' }}>
                                <SearchBar searchList={this.props.supplierMappings} fieldName={'supplierProductName'} searchResults={this.searchResults.bind(this)} />
                            </Grid>
                            <Grid item xs={2} sm={7} />

                            {this.state.noSearchResults === true ?
                                <Grid item xs={12} sm={7}><Typography variant="h2" style={{ marginTop: '20px' }}>No results found</Typography></Grid>
                                : this.props.supplierMappings.length > 0 &&
                                <Grid item sm={12}>
                                    <Table style={{ width: "auto", tableLayout: "auto" }}>
                                        <TableHead>
                                            <TableRow>
                                                <ColHeader context={this} fieldName={'supplierProductName'} title='Supplier Item' onSort={this.onSort.bind(this)} />
                                                <ColHeader context={this} fieldName={'_isMapped'} title='Status' onSort={this.onSort.bind(this)} />
                                                <ColHeader context={this} fieldName={'catalogueProductId'} title='Catalogue Mapping' onSort={this.onSort.bind(this)} />

                                                <ColHeader context={this} fieldName={'askingPrice'} title='Asking price [AU$]' onSort={this.onSort.bind(this)} />
                                                <ColHeader context={this} fieldName={'minimalPriceModifier'} title='Minimal price [AU$]' onSort={this.onSort.bind(this)} />


                                                <ColHeader context={this} fieldName={''} title='Action' onSort={this.onSort.bind(this)} />
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {this.applyPaging(sort(this.state.sortField, this.state.sortAscending, this.getCurrentProductsPage(this.props.supplierMappings))!).map((m, i) => [
                                                <TableRow key={i}>
                                                    <TableCell style={{ borderBottom: 'none', paddingLeft: 0, paddingRight: 0, minWidth: '170px' }}>
                                                        <Typography variant="subtitle2"><b>{m.supplierProductName}</b></Typography>
                                                        {/* <Typography variant="subtitle2"><b>Name: </b>{m.supplierProductName}</Typography> */}
                                                        <div><b>ID: </b>{m.supplierProductId}</div>
                                                    </TableCell>
                                                    <TableCell style={{ borderBottom: 'none', textAlign: 'center' }}>{this.renderStatusCell(m, m.supplierProductId)}</TableCell>
                                                    <TableCell style={{ borderBottom: 'none', minWidth: '180px' }}>{this.renderCatalogueIdCell(m)}</TableCell>

                                                    <TableCell align="center" style={{ borderBottom: 'none' }}>
                                                        <PriceInput
                                                            value={m.askingPrice || 0}
                                                            onLoad={(invalid: boolean) => {
                                                                if (invalid) {
                                                                    let newM = { ...m, _isPriceInvalid: invalid }
                                                                    this.props.updatePrices(newM)
                                                                }
                                                            }}
                                                            label="Asking"
                                                            width="60px"
                                                            disabled={!m._isMapped}
                                                            defaultCurrency='AU$'
                                                            onChange={(v: number, currency: string, invalid: boolean) => {
                                                                let newMinimalPriceModifier = m.minimalPriceModifier ? m.minimalPriceModifier : 1
                                                                let newM: SupplierProductMapping = { ...m, askingPrice: v, minimalPriceModifier: newMinimalPriceModifier, _isDirty: (m._isDirty || v !== m.askingPrice), _isPriceInvalid: invalid }
                                                                this.props.updatePrices(newM)
                                                            }}
                                                            currencies={[]} />
                                                    </TableCell>
                                                    <TableCell align="center" style={{ borderBottom: 'none' }}>
                                                        <PriceInput
                                                            value={Math.round(m.askingPrice * m.minimalPriceModifier * 100) / 100}
                                                            onLoad={(invalid: boolean) => {
                                                                if (invalid) {
                                                                    let newM = { ...m, _isPriceInvalid: invalid }
                                                                    this.props.updatePrices(newM)
                                                                }
                                                            }}
                                                            label="Minimal"
                                                            width="75px"
                                                            disabled={!m._isMapped || !m.askingPrice}
                                                            defaultCurrency='AU$'
                                                            onChange={(v: number, currency: string, invalid: boolean) => {
                                                                let newM = { ...m, minimalPriceModifier: (v / m.askingPrice), _isDirty: (m._isDirty || v !== (m.minimalPriceModifier * m.askingPrice)), _isPriceInvalid: invalid }
                                                                this.props.updatePrices(newM)
                                                            }}
                                                            lowerThan={m.askingPrice}
                                                            currencies={[]}
                                                            endAdornment={
                                                                (() => {
                                                                    let discountString = ""
                                                                    if (m.minimalPriceModifier !== null && m.minimalPriceModifier !== undefined) {
                                                                        let discount = Math.round((1 - m.minimalPriceModifier) * 100) * -1
                                                                        discountString = (discount > 0 ? "+" + discount : discount) + "%"
                                                                    }
                                                                    return (<InputAdornment style={{ fontSize: '0.8rem', color: 'green' }} position="start">{discountString} </InputAdornment>)
                                                                })()}
                                                        />

                                                    </TableCell>

                                                    <TableCell style={{ borderBottom: 'none', textAlign: 'center' }}>
                                                        {m._isDirty && this.props.updateMappingsBusy ?
                                                            <CircularProgress size={50} />
                                                            :
                                                            <Button
                                                                disabled={!m._isDirty || m._isPriceInvalid === true}
                                                                onClick={() => this.props.updateMapping(m)}
                                                                size="small">Save Prices</Button>
                                                        }
                                                    </TableCell>

                                                </TableRow>,
                                                <TableRow key={'b' + i}>
                                                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                                        <Collapse
                                                            key={'bc' + i}
                                                            in={this.state.collapsedRow === m.supplierProductId}
                                                            timeout="auto"
                                                            unmountOnExit
                                                            onExited={() => this.setState({ collapsedRow: this.state.nextToCollapse, nextToCollapse: null })}
                                                            onEntered={(n) => setTimeout(() => {
                                                                let elem = (this.getParent(n, 'MuiTableRow-root') || n)

                                                                let offset = -1 * elem!.previousElementSibling!.clientHeight
                                                                let y = elem.getBoundingClientRect().top + window.pageYOffset + offset
                                                                window.scrollTo({ top: y, behavior: 'smooth' });
                                                            }, 200)}
                                                        >
                                                            <SupplierProductsSearchBoxCnn
                                                                key={'bcs' + i}
                                                                onSaveChange={this.saveMapping}
                                                                searchString={m.catalogueReference ? m.catalogueReference.name : m.supplierProductName.split('(')[0]}
                                                                mappingObj={m}
                                                                onMappingFinish={() => { this.setState({ collapsedRow: null }) }}
                                                                showPriceControls={true}
                                                            />
                                                        </Collapse>
                                                    </TableCell>
                                                </TableRow>
                                            ])}
                                        </TableBody>
                                    </Table>
                                </Grid>
                            }
                            <TablePagination
                                rowsPerPageOptions={pageSizes}
                                component="div"
                                count={this.state.searchResults !== null ? this.state.searchResults.length : this.props.supplierMappings.length}
                                rowsPerPage={this.state.rowsPerPage}
                                page={this.state.currentPage}
                                backIconButtonProps={{
                                    'aria-label': 'Previous Page',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'Next Page',
                                }}
                                labelRowsPerPage={"Products per page:"}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            />
                        </Grid>
                    </div>
                }

                <QmoModal customContent={<OfferFileLoader onCancel={() => this.setState({ loadFromFileModalOpen: false })} onSuccess={() => { this.props.getSupplierMappings() }} sendSupplierOfferBusy={this.props.sendSupplierOfferBusy} sendSupplierOfferSucced={this.props.sendSupplierOfferSucced} sendSupplierOffer={this.props.sendSupplierOfferFile} />}
                    title="Load offer from file."
                    open={this.state.loadFromFileModalOpen}
                />

                <QmoModal
                    customContent={<AddNewProduct close={() => { this.setState({ addNewProductModalOpen: false }); this.props.getSupplierMappings() }} saveMapping={this.saveMapping} />}
                    title="Add new product to your offer."
                    open={this.state.addNewProductModalOpen}
                    minWidth="70vw"
                />
            </div>
        );
    }
}

export default SupplierMappings;